var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmploymentVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 55,
    viewBox: "0 0 61 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.498047,
    width: 60.9677,
    height: 54,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1822)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60171 14.7599C2.24249 14.7599 1.95128 15.0511 1.95128 15.4103V50.0359C1.95128 50.3951 2.24249 50.6863 2.60171 50.6863H54.4445C54.8037 50.6863 55.0949 50.3951 55.0949 50.0359V22.7718H57.0462V50.0359C57.0462 51.4728 55.8813 52.6376 54.4445 52.6376H2.60171C1.16483 52.6376 0 51.4728 0 50.0359V15.4103C0 13.9734 1.16483 12.8086 2.60171 12.8086H37.2804V14.7599H2.60171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5139 14.4509C59.5139 20.5906 54.5368 25.5678 48.3971 25.5678C42.2574 25.5678 37.2803 20.5906 37.2803 14.4509C37.2803 8.31128 42.2574 3.33411 48.3971 3.33411C54.5368 3.33411 59.5139 8.31128 59.5139 14.4509Z",
    fill: "#F3BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4009 19.7198L41.8212 15.1401C41.4402 14.7591 41.4402 14.1414 41.8212 13.7604C42.2022 13.3793 42.8199 13.3793 43.201 13.7604L46.4009 16.9603L53.5954 9.7658C53.9764 9.38478 54.5941 9.38478 54.9751 9.76579C55.3562 10.1468 55.3562 10.7645 54.9751 11.1456L46.4009 19.7198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3976 4.30968C42.7968 4.30968 38.2565 8.85005 38.2565 14.4509C38.2565 20.0517 42.7968 24.5921 48.3976 24.5921C53.9985 24.5921 58.5388 20.0517 58.5388 14.4509C58.5388 8.85005 53.9985 4.30968 48.3976 4.30968ZM36.3052 14.4509C36.3052 7.77238 41.7192 2.3584 48.3976 2.3584C55.0761 2.3584 60.4901 7.77238 60.4901 14.4509C60.4901 21.1294 55.0761 26.5433 48.3976 26.5433C41.7192 26.5433 36.3052 21.1294 36.3052 14.4509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.98 20.3668C15.8247 20.3668 13.2667 22.9248 13.2667 26.0801C13.2667 29.2355 15.8247 31.7935 18.98 31.7935C22.1354 31.7935 24.6934 29.2355 24.6934 26.0801C24.6934 22.9248 22.1354 20.3668 18.98 20.3668ZM11.3154 26.0801C11.3154 21.8471 14.747 18.4155 18.98 18.4155C23.2131 18.4155 26.6447 21.8471 26.6447 26.0801C26.6447 30.3132 23.2131 33.7448 18.98 33.7448C14.747 33.7448 11.3154 30.3132 11.3154 26.0801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13477 39.214C8.13477 36.7734 10.1133 34.7949 12.5538 34.7949H25.4012C27.8418 34.7949 29.8203 36.7734 29.8203 39.214V44.7755C29.8203 45.3144 29.3834 45.7512 28.8446 45.7512C28.3058 45.7512 27.869 45.3144 27.869 44.7755V39.214C27.869 37.8511 26.7641 36.7462 25.4012 36.7462H12.5538C11.1909 36.7462 10.0861 37.8511 10.0861 39.214V44.7755C10.0861 45.3144 9.64924 45.7512 9.11041 45.7512C8.57158 45.7512 8.13477 45.3144 8.13477 44.7755V39.214Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4346 33.8427C34.4346 33.3039 34.8714 32.8671 35.4102 32.8671H49.1839C49.7228 32.8671 50.1596 33.3039 50.1596 33.8427C50.1596 34.3815 49.7228 34.8183 49.1839 34.8183H35.4102C34.8714 34.8183 34.4346 34.3815 34.4346 33.8427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4346 39.309C34.4346 38.7702 34.8714 38.3334 35.4102 38.3334H49.1839C49.7228 38.3334 50.1596 38.7702 50.1596 39.309C50.1596 39.8478 49.7228 40.2847 49.1839 40.2847H35.4102C34.8714 40.2847 34.4346 39.8478 34.4346 39.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4346 44.7756C34.4346 44.2367 34.8714 43.7999 35.4102 43.7999H49.1839C49.7228 43.7999 50.1596 44.2367 50.1596 44.7756C50.1596 45.3144 49.7228 45.7512 49.1839 45.7512H35.4102C34.8714 45.7512 34.4346 45.3144 34.4346 44.7756Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentVerification);
export default __webpack_public_path__ + "static/media/employment_verification.ba4d7b3f325f22480cfcf17e37138922.svg";
export { ForwardRef as ReactComponent };